import {useParams} from "react-router-dom";
import {AppPage} from "common/Layout";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import {FirstPracticalModule} from "pages/PracticalModule/components/FirstPracticalModule";
import {SecondPracticalModule} from "pages/PracticalModule/components/SecondPracticalModule";
import type {PracticalModulePage as PracticalModulePageType} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import {PageType} from "../../config/types";
import styles from "./styles.module.scss";

type IdParams = { id: string; }

export const PracticalModulePage = () => {
  const {id} = useParams<IdParams>();
  const currentPracticalModule = GLOBAL_CONFIG.pages.find(page => page.type === PageType.PRACTICAL_MODULE && page.id === id) as PracticalModulePageType;

  if (!currentPracticalModule) {
    return null;
  }

  return (
    <AppPage
      contentClassName={styles.content}
      pageTitle="Практический модуль"
      documentTitle="Практический модуль"
      style={{backgroundImage: `url(${currentPracticalModule.imagePath})`}}
    >
      <AppFlex unit="0" className={styles.container} justifyContent="flex-start">
        <AppText size={24}>Практический модуль. Часть { id }</AppText>
        {id === "1" && <FirstPracticalModule practicalModule={currentPracticalModule}/>}
        {id === "2" && <SecondPracticalModule practicalModule={currentPracticalModule}/>}
      </AppFlex>
    </AppPage>
  );
};
